import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {t} from "@i18n";
import {SaveButton} from "_ui/Button";
import {Flex} from "_ui/Box";
import {FormInput, VerticalForm} from "_components/form";
import type {PartialCurrentUser} from "_types/responses/auth";
import {Field} from "_utils/txt";

type Props = {
    onSubmit: (data: PartialCurrentUser) => void;
    defaultValues?: PartialCurrentUser | undefined;
    loading?: boolean;
}

export const DetailsForm = ({onSubmit, defaultValues, loading}: Props) => {

    const resolver = yupResolver(
        yup.object().shape({
            name: yup.string().required(t(Field.required)),
        })
    ) as any;

    return (
        <VerticalForm<PartialCurrentUser>
            {...{onSubmit, resolver, defaultValues}}
            formClass='w-100'
        >
            <FormInput
                label={t('Name')}
                type="text"
                name="name"
                placeholder={t('Name')}
                containerClass={'mb-2'}
            />

            <Flex row end g={5}>
                <SaveButton submit {...{loading}} />
            </Flex>
        </VerticalForm>
    );
};
